module.exports = [{
      plugin: require('../.yarn/unplugged/gatsby-virtual-176079ecbc/node_modules/gatsby/dist/internal-plugins/partytown/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
